export const SAFETY_TIMEOUT_MS = 60_000;
export const MAX_TEXTAREA_HEIGHT = 120;
export const MAX_STORED_MODES = 100;

// Staleness cutoff for the planner-running gate (usePlannerStaleCutoff). 90s is
// deliberately longer than every self-heal channel: the 60s isWaitingForResponse
// safety timeout (SAFETY_TIMEOUT_MS) and the 60s by-id fallback poll
// (useChat.FALLBACK_POLL_MS). The cutoff therefore only fires when ALL of those
// channels have already missed — i.e. the planner signal is wedged by genuinely
// stale data (e.g. a dropped active->idle conversation MODIFY), not by an
// in-flight run.
export const PLANNER_STALE_CUTOFF_MS = 90_000;
